import { Backend } from './backend';
import { ProductForm, ProductForms } from './productForm';

export interface CatalogFormAnswer {
  id?: number;
  value: string | number | boolean;
  question_id?: number;
  errors?: string[];
}

export type CatalogFormAnswers = CatalogFormAnswer[];

export interface CatalogFormReply {
  id: number;
  form_id: number;
  answers: CatalogFormAnswers;
  /**
   * Indicates whether a form should be shown immediately to the user (= false) or not (= true)
   */
  submitted: boolean;
}

export type CatalogFormReplies = CatalogFormReply[];

export async function getForms(options?: RequestInit) {
  return Backend.get<ProductForms>(`/catalog/forms`, options);
}

export async function getForm(formId: number, options?: RequestInit) {
  return Backend.get<ProductForm>(`/catalog/forms/${encodeURIComponent(formId)}`, options);
}

export async function replyToForm(formId: number, answers: CatalogFormAnswers, options?: RequestInit) {
  return Backend.post<ProductForm>(`/forms/${encodeURIComponent(formId)}/reply`, {
    ...options,
    body: JSON.stringify({
      answers,
    }),
  });
}
